import React, { useRef } from "react";
import useDragScroll from "use-drag-scroll";

// import arrowDownIcon from "../assets/img/arrow-down.svg";

export default function TablePercentil({ inputDropdownRaca, result }) {
  // useEffect(() => {
  //   if(result && result.length > 0){
  //     result.map((res) => {
  //       res && res.valores && res.valores.length > 0 && (
  //         res.valores.map((v) => {

  //         })
  //       )
  //     })
  //   }
  // },[result])

  const ref = useRef(null);

  useDragScroll({
    sliderRef: ref,
  });

  return (
    <>
      <div className="table-vertical">
        <div className="table-vertical-header">
          <h2>Raça Selecionada: {inputDropdownRaca}</h2>
        </div>
        <div className="table-vertical-body table-draggable" ref={ref}>
          {/* Coluna de referencia com a faixa (Top %) de cada linha - sem ela
              os numeros das colunas de DEP nao tem contexto (linha 1 e a faixa
              0.1%? 50%? nao dava pra saber). Todas as colunas de "result" tem
              o mesmo numero de linhas, na mesma ordem, entao usamos a
              primeira coluna so para pegar os rotulos. */}
          {result && result.length > 0 && result[0].valores && result[0].valores.length > 0 && (
            <div className="table-vertical-col table-vertical-col--faixa">
              <div className="table-vertical-col-item-header">Top %</div>
              {result[0].valores.map((v, idx) => (
                <div className="table-vertical-col-item" key={idx}>
                  <span>{v.top || ""}</span>
                </div>
              ))}
            </div>
          )}
          {result &&
            result.length > 0 &&
            result.map((r, index) => (
              <div className="table-vertical-col" key={index}>
                <div className="table-vertical-col-item-header">
                  {r.caracteristica}
                </div>
                {r &&
                  r.valores &&
                  r.valores.length > 0 &&
                  r.valores.map((v, idx) => (
                    <div className="table-vertical-col-item" key={idx}>
                      <span>{v.valor ? v.valor : ""}</span>
                    </div>
                  ))}
              </div>
            ))}
        </div>
      </div>
    </>
  );
}
